import {ShipmentDocumentMetadataTypeEnum} from '@shipwell/backend-core-sdk';
import {toTitleCase} from 'App/utils/globals';

export const getDocumentTitle = (documentType: string) =>
  [ShipmentDocumentMetadataTypeEnum.Bol, ShipmentDocumentMetadataTypeEnum.Hos].some(
    (docType) => docType === documentType
  )
    ? documentType
    : toTitleCase(documentType);
